import { To, useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import CompanyDocumentsDataTable from 'modules/documents/components/CompanyDocumentsDatatable'
import filesStore from 'modules/documents/components/Documents/store'
import Folders from 'modules/documents/components/DocumentsAndFolders/FoldersList'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { isCompanyPublicSpace } from 'modules/documents/lib/Documents'
import { SPACES } from 'modules/documents/lib/constants'

interface Props {
  folder: Folder
  canUploadDocument: boolean
  selectedFolder?: Folder
  setSelectedFolder: (folder?: Folder) => void
  parentRoute: To
}

const FolderContent = ({
  folder,
  canUploadDocument,
  selectedFolder,
  setSelectedFolder,
  parentRoute,
}: Props) => {
  const readonly = !canUploadDocument || folder.showOnly
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const space = isCompanyPublicSpace(folder.space) ? SPACES.COMPANY_PUBLIC : SPACES.COMPANY_INTERNAL

  const onDrop = (files: File[], _newFolder?: Folder) => {
    if (!canUploadDocument) return
    setSelectedFolder(folder)

    filesStore.concat(files)

    if (selectedFolder) {
      navigate(newUrl)
    }
  }

  const newUrl = isCompanyPublicSpace(folder.space)
    ? navigation.files.companyFiles.folderId.new.fullPath({ folderId: folder.id })
    : navigation.files.managementDocuments.folderId.new.fullPath({
        folderId: folder.id,
      })

  const onUpload = () => {
    if (!canUploadDocument) return

    setSelectedFolder(folder)

    if (selectedFolder) {
      navigate(newUrl)
    }
  }

  const onNavigationClick = (documentId: string) => {
    let documentUrl = ''

    if (isCompanyPublicSpace(folder.space)) {
      documentUrl = navigation.files.companyFiles.folderId.documentId.fullPath({
        document_id: documentId,
        folderId: folder.id,
      })
    } else {
      documentUrl = navigation.files.managementDocuments.folderId.documentId.fullPath({
        document_id: documentId,
        folderId: folder.id,
      })
    }

    navigate(documentUrl)
  }

  return (
    <>
      <Box paddingY="s8">
        <Folders
          space={space}
          parentFolderId={folder.id}
          readonly={readonly}
          onFolderSelected={setSelectedFolder}
        />
      </Box>
      <Box gap="s8" paddingTop="s8">
        <CompanyDocumentsDataTable
          folder={folder}
          initialFolder={selectedFolder}
          parentRoute={parentRoute}
          readonly={!canUploadDocument}
          onDrop={onDrop}
          space={space}
          onNavigationClick={onNavigationClick}
          onUpload={onUpload}
        />
      </Box>
    </>
  )
}

export default observer(FolderContent)
